$(function(){
  var armsImg=0;
  var armsTab=0;
  $('.arms_btm li').click(function(){
    armsImg=$(this).index();
    $('.arms_btm li').removeClass("arms_focus").eq(armsImg).addClass("arms_focus");
    $(".arms_top_img img").attr("src","img/arms"+armsImg+"_"+armsTab+".jpg?v=1")
  });
  $('.arms_top span').click(function(){
    armsTab=$(this).index();
    $('.arms_top span').removeClass("icon-arms_list2").eq(armsTab).addClass("icon-arms_list2");
    $(".arms_top_img img").attr("src","img/arms"+armsImg+"_"+armsTab+".jpg?v=1")
  })
});